/** Render-only drafts. Choosing a style never submits a job or changes a take. */
export const transitionPacks = [
  {
    id: "original",
    name: "Original",
    cue: "Keep your edit",
    description: "Use the transitions already planned in your storyboard.",
  },
  {
    id: "cinematic",
    name: "Cinema",
    cue: "Let it breathe",
    description:
      "Short dissolves with clean cuts. A softer, restrained rhythm.",
  },
  {
    id: "flow",
    name: "Flow",
    cue: "Keep it moving",
    description:
      "Directional slides and smooth sweeps, balanced with clean cuts.",
  },
  {
    id: "punch",
    name: "Punch",
    cue: "Hit the accent",
    description:
      "Brief zooms, blur blends and diagonal reveals between clean cuts.",
  },
  {
    id: "graphic",
    name: "Graphic",
    cue: "Make a statement",
    description: "Wipes, circular reveals, radial motion and pixel dissolves.",
  },
] as const;
type PackId = (typeof transitionPacks)[number]["id"];
const drafts = new Map<string, PackId>();
export function transitionPackFor(projectId: string): PackId {
  return drafts.get(projectId) || "original";
}
export function chooseTransitionPack(
  projectId: string,
  value: string,
): boolean {
  if (!transitionPacks.some((pack) => pack.id === value)) return false;
  drafts.set(projectId, value as PackId);
  return true;
}
